import { Routes } from '@angular/router';
import { OperateursComponent } from './operateurs.component';
import { RechercheOperateurAffilieComponent } from './pages/recherche-operateur-affilie/recherche-operateur-affilie.component';
import { AjoutOperateurComponent } from './pages/ajout-operateur/ajout-operateur.component';
import { OperateurDashboardComponent } from './pages/operateur-dashboard/operateur-dashboard.component';
import { OperateurHabilitationsComponent } from './pages/operateur-habilitations/operateur-habilitations.component';
import { InformationsOperateurComponent } from './pages/informations-operateur/informations-operateur.component';
import { ParcellaireViticoleComponent } from '../parcellaire-viticole/parcellaire-viticole.component';
import { SyntheseVolumesComponent } from '../declarations/pages/synthese-volumes/synthese-volumes.component';
import { AffichageDrComponent } from '../declarations/pages/affichage-dr/affichage-dr.component';
import { AffichageDrevComponent } from '../declarations/pages/affichage-drev/affichage-drev.component';
import { ConsultationDrevComponent } from '../declarations/pages/consultation-drev/consultation-drev.component';
import { HISTORIQUE_ROUTES } from '../declarations/pages/historique/historique.routes';
import { REGISTRE_VCI_ROUTES } from '../declarations/pages/registre-vci/registre-vci.routes';
import { OPERATEUR_CONTROLE_ROUTES } from './pages/operateur-controle/operateur-controle.routes';
import { PARCELLAIRE_VITICOLE_ROUTES } from '../parcellaire-viticole/parcellaire-viticole.route';

export const OPERATEURS_ROUTES: Routes = [
    { path: '', redirectTo: 'or', pathMatch: 'full' },
    {
        path: 'or',
        data: {
            role: 'ADMIN || ORGANISME',
            domaines: ['VIN'],
            menu: {
                icon: 'users-cog',
                libelle: 'menu.operateurs'
            }
        },
        children: [
            { path: '', redirectTo: 'recherche-affilie', pathMatch: 'full' },
            { path: 'recherche-affilie', component: RechercheOperateurAffilieComponent, title: 'Rechercher un opérateur' },
            { path: 'ajout-operateur', component: AjoutOperateurComponent },
            {
                path: ':idOperateur',
                component: OperateursComponent,
                children: [
                    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
                    {
                        path: 'dashboard',
                        title: 'Tableau de bord',
                        children: [
                            {
                                path: '',
                                component: OperateurDashboardComponent,
                                data: {
                                    menu: {
                                        icon: 'chart-bar',
                                        libelle: 'menu.operateurs-dashboard'
                                    }
                                }
                            }
                        ]
                    },
                    {
                        path: 'habilitations',
                        title: 'Habilitations',
                        children: [
                            {
                                path: '',
                                component: OperateurHabilitationsComponent,
                                data: {
                                    role: 'HABILITATION_HABILITATION_LECTURE || HABILITATION_HABILITATION_ECRITURE',
                                    menu: {
                                        icon: 'user-check',
                                        libelle: 'menu.habilitation'
                                    }
                                }
                            }
                        ]
                    },
                    {
                        path: 'informations',
                        title: 'Informations et sites',
                        children: [
                            {
                                path: '',
                                component: InformationsOperateurComponent,
                                data: {
                                    menu: {
                                        icon: 'building',
                                        libelle: 'menu.operateur-informations'
                                    }
                                }
                            }
                        ]
                    },
                    {
                        path: 'parcellaire',
                        title: 'Parcellaire',
                        children: PARCELLAIRE_VITICOLE_ROUTES
                    },
                    {
                        path: 'synthese',
                        title: 'Synthèse',
                        children: [
                            { path: '', component: SyntheseVolumesComponent, data: { menu: { libelle: 'menu.synthese', icon: 'balance-scale' } } },
                            { path: ':campagne', component: SyntheseVolumesComponent, data: { title: 'menu.synthese' } }
                        ]
                    },
                    { path: 'historique', title: 'Historique des lots', children: HISTORIQUE_ROUTES },
                    { path: 'registreVci', title: 'Registre VCI', children: REGISTRE_VCI_ROUTES },
                    {
                        path: 'dr/:annee',
                        title: 'Données ProDouanes',
                        component: AffichageDrComponent,
                        data: {
                            menu: { libelle: 'Données ProDouanes' }
                        }
                    },
                    { path: 'drev/:annee', title: 'Drev AOC / DR IGP', component: AffichageDrevComponent },
                    {
                        path: 'consultation',
                        children: [
                            { path: '', component: ConsultationDrevComponent, data: { menu: { libelle: 'Drev AOC / DR IGP' } } },
                            { path: ':annee', component: ConsultationDrevComponent }
                        ]
                    },
                    { path: 'controle', title: 'Contrôle', children: OPERATEUR_CONTROLE_ROUTES },
                    { path: '**', redirectTo: 'recherche-affilie' }
                ]
            }
        ]
    },
    {
        path: 'op',
        data: { role: 'OPERATEUR' },
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            {
                path: 'home',
                children: [
                    {
                        path: '',
                        component: OperateurDashboardComponent,
                        data: {
                            menu: {
                                icon: 'chart-bar',
                                libelle: 'menu.operateurs-dashboard'
                            }
                        }
                    }
                ]
            },
            {
                path: 'informations',
                children: [
                    {
                        path: '',
                        component: InformationsOperateurComponent,
                        data: {
                            menu: {
                                icon: 'building',
                                libelle: 'menu.operateur-informations'
                            }
                        }
                    }
                ]
            }
        ]
    }
];
